<template>
  <v-snackbar
    :key="renderKey"
    :value="show"
    :color="color"
    transition="slide-x-reverse-transition"
    timeout="5000"
    app
    right
    bottom
    elevation="1"
    @input="onInput"
  >
    <span class="snackbar-message">{{ message }}</span>
    <template #action="{attrs}">
      <v-btn text v-bind="attrs" @click.stop="close">
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  name: 'CustomToaster',
  data() {
    return {
      show: false,
      message: '',
      color: 'green',
      renderKey: 0,
      isProcessing: false,
    }
  },
  computed: {
    ...mapState({queue: (state) => state.toastQueue || []}),
  },
  watch: {
    'queue.length'(len) {
      if (!this.show && !this.isProcessing && len > 0) {
        this.showNext()
      }
    },
    immediate: true,
  },
  methods: {
    ...mapActions({
      removeCurrent: 'CLOSE_TOAST',
    }),

    showNext() {
      const next = this.queue[0]
      if (!next) return

      this.message = next.message
      this.color = next.color
      this.renderKey++
      this.show = true
    },
    onInput(isOpen) {
      if (!isOpen && !this.isProcessing) {
        this.close()
      }
    },

    close() {
      this.isProcessing = true
      this.show = false
      this.removeCurrent()

      setTimeout(() => {
        this.isProcessing = false
        if (this.queue.length > 0) {
          this.showNext()
        }
      }, 300)
    },
  },
}
</script>
<style lang="scss">
.snackbar-message {
  white-space: pre-line;
  font-size: 1rem;
}
</style>
